import React, { useState, useEffect } from "react";
import "../Styles/HeroSlider.css";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    id: 1,
    text: "We Can Help Someone",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 2,
    text: "Together We Can Make a Change",
    image:
      "https://images.unsplash.com/photo-1509099836639-18ba1795216d?auto=format&fit=crop&w=1200&q=80"
  },
  {
    id: 3,
    text: "Your Support Brings Hope",
    image:
      "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1200&q=80"
  }
];

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="slider">
      <div
        className="slide"
        style={{ backgroundImage: `url(${slides[current].image})` }}
      >
        <div className="overlay">
          <h1>{slides[current].text}</h1>
           <button 
            className="donate-now" 
            onClick={() => navigate("/payment")}
          >Donate Now</button>
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
